<template lang="pug">
#water_treatment
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_water_treatment.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_water_treatment_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
        //- router-link(to="/#application" ) 123
    div.banner_h1
      h1 水處理
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 本製品之加工方式有軋壓及成型兩種。客戶若使用成型方式加工，則須特別管制成型性。
  section#product_profile
    b-row.menu
      //- b-col.text-center.position-relative.active(v-scroll-to="'#others'") PVC
      b-col.text-center.position-relative.active(v-scroll-to="'#others'") PVC
    b-container.pt-md-4
      b-row#pvc_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 本製品剛性佳、具有優良耐化學藥品性，熱變形溫度高，可達耐燃防煙等級。
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in p_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol.list-unstyled.pl-0
              li(v-for="item in p_use" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品證書
            a.linkcus(href="img/certification/VWWA_FF(ASTM_E84).pdf" target="_blank")
              figure
                figcaption VWWA FF (ASTM E84)
                img(src="img/certification/certification_VWWA_FF(ASTM_E84).jpg" alt="certification VWWA FF(ASTM E84)")
            a.linkcus(href="img/certification/VWWA_FE(ASTM_E84)-SGS.pdf" target="_blank")
              figure
                figcaption VWWA FE (ASTM E84)
                img(src="img/certification/certification_VWWA_FE(ASTM_E84)_2.jpg" alt="certification VWWA FE(ASTM E84)-SGS")
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span PVC 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_pvc").swiper_pvc.swiper_product_col_3
        swiper-slide(v-for="item in p_specification" :key="item.id")
          ul
            li 
              span {{ item.name }}
            li 
              span {{ item.feature }}
            li 
              span {{ item.outward }}
            li 
              span(v-html="item.thickness")
            li 
              span(v-html="item.proportion")
            li 
              span(v-html="item.pull")
            li 
              span(v-html="item.elongation")
            li 
              span(v-html="item.heating")
            li 
              span(v-html="item.vcm")
        <div class="swiper-pagination" slot="pagination"></div>
  section#video
    b-container.py-5
      h3.text-center.mb-4 南亞PVC水塔板應用實例
      div.embed-responsive.embed-responsive-16by9
        iframe.embed-responsive-item(src="https://www.youtube.com/embed/Ye7K8jGgC_c?rel=0" title="南亞PVC水塔板應用實例" )
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'PVC水處理-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'PVC硬質膠布具有優良耐化學藥品性，熱變形溫度高，適合經成型加工製成冷卻水塔填充材或廢水處理板達到水處理的效果。有一般水塔板用、耐溫水塔板用等。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、PVC、水處理、水塔板、耐溫。' },
            { name: 'og:title', content: 'PVC水處理-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'PVC硬質膠布具有優良耐化學藥品性，熱變形溫度高，適合經成型加工製成冷卻水塔填充材或廢水處理板達到水處理的效果。有一般水塔板用、耐溫水塔板用等。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          // {
          //   text: '應用',
          //   to: { name: 'App' },
          //   scroll: '#application'
          // },
          {
            text: '水處理',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/application_Desktop/water_treatment_img-01.jpg',
            img_alt: 'PVC硬質膠布具有優良耐化學藥品性，熱變形溫度高，製成冷卻水塔填充材或廢水處理板，可增進水處理的效果' },
          { 
            id: '2',
            img_src: 'img/application_Desktop/water_treatment_img-02.jpg',
            img_alt: 'PVC硬質膠布具有優良耐化學藥品性，熱變形溫度高，製成冷卻水塔填充材或廢水處理板，可增進水處理的效果' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        p_feature: [
          { message: '剛性佳，使用時不易變形。' },
          { message: '散水性良好，冷卻效果佳。' },
          { message: '耐化學藥品性佳。' },
          { message: '熱變形溫度高。' },
          { message: '可依客戶需求，生產耐溫與耐燃防煙等產品。' },
          { message: '符合歐盟REACH、ROHS規範要求。' }
        ],
        p_use: [
          { message: '適合軋壓與成型加工、製成冷卻水塔散熱片或廢水處理板達到水處理的效果。' }
        ],
        p_specification: [
          { 
            id: '1',
            name: '一般水塔板VWWC',
            feature: '特色: 剛性佳、散水性良好',
            outward: '外觀: 有色、亮面、霧面',
            thickness: '參考厚度<sub>(mm)</sub>：0.30 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.40±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>:<br/><span class="pl-5">MD>400/CD>300</span>',
            elongation: '伸長率<sub>(%)</sub>：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-9~-16/CD<5</span>',
            vcm: 'VCM含量<sub>(ppm)</sub>：未管制' },
          { 
            id: '2',
            name: '耐溫水塔板VWWW',
            feature: '特色: 熱變形溫度高、剛性佳、散水性良好',
            outward: '外觀: 有色、亮面、霧面',
            thickness: '參考厚度<sub>(mm)</sub> ：0.30',
            proportion: '比重<sub>(g/cm3)</sub> ：1.46±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub> ：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-6~-15/CD<3</span>',
            vcm: 'VCM含量(ppm)</sub>：未管制' },
          { 
            id: '3',
            name: '耐燃水塔板VWWA',
            feature: '特色：符合ASTM-E84、UL-94 耐燃防煙要求、剛性佳、散水性良好',
            outward: '外觀：有色、亮面、霧面',
            thickness: '參考厚度<sub>(mm)</sub> ：0.30',
            proportion: '比重<sub>(g/cm3)</sub> ：1.44±3%',
            pull: '拉力強度<sub>(kg/cm2)</sub>：<br/><span class="pl-5">MD>450/CD>400</span>',
            elongation: '伸長率<sub>(%)</sub> ：<br/><span class="pl-5">MD>80/CD>80</span>',
            heating: '加熱收縮<sub>(%,150°CX10分)</sub>：<br/><span class="pl-5">MD-6~-15/CD<3</span>',
            vcm: 'VCM含量(ppm)</sub>：未管制' }
        ],
        swiperOption_pvc: {
          slidesPerView: 3,
          spaceBetween: 30,
          breakpoints: {
            790: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'食藥醫療',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_1.jpg',
            href_link: 'Food-and-medicine'
          },
          {
            id:'2',
            name:'抗靜電包裝',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/application_Desktop/other_pic_2.jpg',
            href_link: 'anti_static'
          },
          {
            id:'3',
            name:'建材裝潢',
            text:'在連續基材上，經過印刷、塗佈、貼合或壓製等工藝而製成的產品。 複合塑膠建材裝璜產品是由多層結構熱壓而成..',
            url:'./img/application_Desktop/other_pic_3.jpg',
            href_link: 'decoration'
          },
          {
            id:'4',
            name:'卡片貼合',
            text:'本製品可經印刷、貼合、衝卡、打碼、分卡質檢等工序製成各種卡片。',
            url:'./img/application_Desktop/other_pic_4.jpg',
            href_link: 'card_Lamination'
          },
          {
            id:'5',
            name:'事務文具',
            text:'本製品可經印刷、貼合、沖裁或熔著等工序製成各種事務文具用產品。',
            url:'./img/application_Desktop/other_pic_5.jpg',
            href_link: 'office_stationery'
          },
          {
            id:'7',
            name:'Green APET',
            text:'PCR粒是回收寶特瓶再生原料，達到重複使用、再生循環，符合低碳排放與減廢之環保訴求',
            url:'./img/application_Desktop/other_pic_7.jpg',
            href_link: 'green_apet'
          },
          {
            id:'8',
            name:'C-PET膠布',
            text:'C-PET膠布需經由壓空成型機模具加熱成型使其結晶，成型品可耐高溫。',
            url:'./img/application_Desktop/other_pic_8.jpg',
            href_link: 'Cpet-sheet'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#water_treatment
  #specification
    background-image: url(../assets/bg/bg_water_treatment.jpg)
.linkcus,.linkcus:hover
  text-decoration: none
  color: #1E1E1E
  figure
    padding-right: 15px
    text-align: center
    display: inline-block
    figcaption
      padding-bottom : 8px

</style>
